module.exports = __webpack_public_path__ + "media/src/public/images/logo-and-name-a230fd22564072619e7c34b67a1c8979.svg";